import { render, staticRenderFns } from "./WineListPriceList.vue?vue&type=template&id=79181b1a&"
import script from "./WineListPriceList.vue?vue&type=script&lang=js&"
export * from "./WineListPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports